export default "__VITE_ASSET__gzTLccIp__"